import ProjectAsset from '~/models/ProjectData/ProjectAsset'

/**
 * @memberOf ProjectData
 * @extends ProjectData.ProjectAsset
 *
 */

class ProjectTextAsset extends ProjectAsset {

  // eslint-disable-next-line no-unused-vars
  constructor(jsonData, version) {
    super(jsonData)

    const { settings, mediaFileDuration, originDuration, isInitialized } = jsonData

    this._originDuration = originDuration || mediaFileDuration
    this._mediaFileDuration = mediaFileDuration
    this._isInitialized = isInitialized || false
    this._settings = { ...settings }
  }

  get mediaFileDuration() {
    return this._mediaFileDuration
  }

  /**
   * @param {number} mediaFileDuration
   */
  set mediaFileDuration(mediaFileDuration) {
    this._mediaFileDuration = mediaFileDuration
  }

  /**
   * @returns {number}
   */
  get settings() {
    return this._settings
  }

  get isInitialized() {
    return this._isInitialized
  }

}

export default ProjectTextAsset
